import React, { useCallback } from 'react';
import { LobbyGameSwitcher } from './LobbyGameSwitcher';
import {
  LobbyPlayModesRow,
  POKER_LOBBY_PLAY_TILES,
  LobbyBottomNav,
} from './lobbyHubShared';
import { LobbyTablesBlock } from './LobbyTablesBlock';
import { useLobbySekaTables } from '../hooks/useLobbySekaTables';
import { HUB_SOCKET_PHASE } from '../realtime/connectionUx';
import './Lobby.css';

function PokerLobby({
  user,
  socket,
  hubSocketPhase = HUB_SOCKET_PHASE.IDLE,
  onOpenWallet,
  onOpenPracticeTable,
  onOpenOnline,
  onOpenBelot,
  onBack,
  onJoinTable,
  onOpenGifts,
  onOpenFriends,
  giftsNavBadgeCount = 0,
  friendsNavBadgeCount = 0,
  onOpenHubJoinOnlineLobby,
  onOpenOnlineCreateRoom,
}) {
  const tableState = useLobbySekaTables({
    socket,
    user,
    onJoinTable,
    lobbyMode: 'poker',
    lobbyReturnView: 'poker-lobby',
  });

  const handleModeTileClick = useCallback(
    (tile) => {
      if (tile.id === 'poker-bots') {
        onOpenPracticeTable();
      } else if (tile.id === 'poker-online') {
        onOpenOnline?.();
      }
    },
    [onOpenOnline, onOpenPracticeTable]
  );

  return (
    <div className="lobby-mp mx-auto flex min-h-0 w-full max-w-lg flex-1 flex-col overflow-hidden px-3 pt-1.5 sm:max-w-3xl lg:max-w-5xl">
      <div className="lobby-mp-scroll safe-scroll-top min-h-0 flex-1 overflow-y-auto overscroll-y-contain pb-[var(--lobby-bottom-nav-h)] pt-0.5 [scroll-padding-bottom:var(--lobby-bottom-nav-h)]">
        <LobbyPlayModesRow
          socket={socket}
          tiles={POKER_LOBBY_PLAY_TILES}
          onTileClick={handleModeTileClick}
        >
          <LobbyGameSwitcher
            active="poker"
            onSelectSeka={onBack}
            onSelectPoker={() => {}}
            onSelectBelot={onOpenBelot}
            pokerHint="Превью"
          />
        </LobbyPlayModesRow>

        <LobbyTablesBlock
          mode="poker"
          user={user}
          onJoinTable={onJoinTable}
          onPlayThroughOnlineLobby={
            onOpenHubJoinOnlineLobby
              ? (table) =>
                  onOpenHubJoinOnlineLobby({
                    roomCode: String(table?.id ?? '')
                      .trim()
                      .toUpperCase(),
                    isPrivate: Boolean(table?.isPrivate),
                    origin: 'poker-lobby',
                  })
              : undefined
          }
          hubSocketPhase={hubSocketPhase}
          onOpenCreateRoom={() => onOpenOnlineCreateRoom?.()}
          {...tableState}
        />
      </div>

      <LobbyBottomNav
        mode="poker"
        onOpenGifts={onOpenGifts}
        onOpenFriends={onOpenFriends}
        onOpenCreateRoom={() => onOpenOnlineCreateRoom?.()}
        giftsNavBadgeCount={giftsNavBadgeCount}
        friendsNavBadgeCount={friendsNavBadgeCount}
      />
    </div>
  );
}

export default PokerLobby;
